import { useDispatch, useSelector } from "react-redux";
import { LoginCard } from "../components/LoginCard";
import { login } from "../redux/slices/authSlice";
import { RootState } from "../redux/store";
import { setLoginModalState } from "../redux/slices/popupModalSlices";
import { useState } from "react";
import { LoginCredentials } from "../types/userData.types";
import { loginCall } from "../services/authService";

export default function Login() {
  const dispatch = useDispatch();
  const [errorMessage, setErrorMessage] = useState({ email: "", password: "" });
  const isModalVisible = useSelector(
    (state: RootState) => state.popup.showLoginModal
  );

  if (!isModalVisible) {
    return null;
  }

  const handleLogin = async (result: LoginCredentials) => {
    const { data, error } = await loginCall(result);

    if (data) {
      dispatch(login(data));
      dispatch(setLoginModalState(false));
    } else {
      if (error && typeof error === "object") {
        setErrorMessage(error);
      }
    }
  };

  const handleClose = () => {
    dispatch(setLoginModalState(false));
  };

  return (
    <LoginCard
      onSubmit={handleLogin}
      onClose={handleClose}
      setErrorMessage={setErrorMessage}
      emailError={errorMessage?.email}
      passwordError={errorMessage?.password}
    />
  );
}
